export default "__VITE_ASSET__D4$TVVAd__"